/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesTenantBillingDtosGenerateMonthlyTenantInvoicesRequest,
  FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto,
  FacilityFlowCoreModulesTenantBillingWorkflowsGenerateMonthlyTenantInvoicesResponse,
  GetApiV1TenantBillingInvoicesParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTenantInvoices = () => {
const getApiV1TenantBillingInvoices = (
    params?: GetApiV1TenantBillingInvoicesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto[]>(
      {url: `/api/v1/tenant-billing/invoices`, method: 'GET',
        params
    },
      options);
    }
  const getApiV1TenantBillingInvoicesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>(
      {url: `/api/v1/tenant-billing/invoices/${id}`, method: 'GET'
    },
      options);
    }
  const getApiV1TenantBillingInvoicesIdPdf = (
    id: string,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/tenant-billing/invoices/${id}/pdf`, method: 'GET',
        responseType: 'blob'
    },
      options);
    }
  const postApiV1TenantBillingInvoicesGenerateMonthly = (
    facilityFlowCoreModulesTenantBillingDtosGenerateMonthlyTenantInvoicesRequest: FacilityFlowCoreModulesTenantBillingDtosGenerateMonthlyTenantInvoicesRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantBillingWorkflowsGenerateMonthlyTenantInvoicesResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantBillingWorkflowsGenerateMonthlyTenantInvoicesResponse>(
      {url: `/api/v1/tenant-billing/invoices/generate-monthly`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesTenantBillingDtosGenerateMonthlyTenantInvoicesRequest
    },
      options);
    }
  const patchApiV1TenantBillingInvoicesIdMarkPaid = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>(
      {url: `/api/v1/tenant-billing/invoices/${id}/mark-paid`, method: 'PATCH'
    },
      options);
    }
  const patchApiV1TenantBillingInvoicesIdCancel = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTenantBillingDtosTenantInvoiceDto>(
      {url: `/api/v1/tenant-billing/invoices/${id}/cancel`, method: 'PATCH'
    },
      options);
    }
  return {getApiV1TenantBillingInvoices,getApiV1TenantBillingInvoicesId,getApiV1TenantBillingInvoicesIdPdf,postApiV1TenantBillingInvoicesGenerateMonthly,patchApiV1TenantBillingInvoicesIdMarkPaid,patchApiV1TenantBillingInvoicesIdCancel}};
export type GetApiV1TenantBillingInvoicesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenantInvoices>['getApiV1TenantBillingInvoices']>>>
export type GetApiV1TenantBillingInvoicesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenantInvoices>['getApiV1TenantBillingInvoicesId']>>>
export type GetApiV1TenantBillingInvoicesIdPdfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenantInvoices>['getApiV1TenantBillingInvoicesIdPdf']>>>
export type PostApiV1TenantBillingInvoicesGenerateMonthlyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenantInvoices>['postApiV1TenantBillingInvoicesGenerateMonthly']>>>
export type PatchApiV1TenantBillingInvoicesIdMarkPaidResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenantInvoices>['patchApiV1TenantBillingInvoicesIdMarkPaid']>>>
export type PatchApiV1TenantBillingInvoicesIdCancelResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTenantInvoices>['patchApiV1TenantBillingInvoicesIdCancel']>>>
